import React, { useState } from "react";
import "../../index.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";

export default function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login, isLoading } = useAuth();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !password) {
      setError("Please enter both email and password.");
      return;
    }

    setError("");
    try {
      await login(username, password);
      navigate("/dashboard");
    } catch (err: any) {
      console.error("Login failed", err);
      setError("Invalid credentials or server error.");
    }
  };

  if (isLoading) return <p>Loading...</p>;

  return (
    <div className="login-wrapper">
      <div className="login-glass-card">
        <header className="login-header">
          <div className="logo-dark">
            <span className="at-dark">@</span>
            <span className="word-dark">tlas</span>
          </div>
          <p>Welcome back to your dashboard</p>
        </header>

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <label>Username</label>
            <input
              placeholder="Your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
